import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import routes from "../../../pages/routes";

const EnrolmentSuccessful = () => {
  const navigate = useNavigate();

  return (
    <>
      <DashboardHeader />

      <Flex
        justifyContent="center"
        bg="#F9F8F8"
        minHeight="100vh"
        height={"auto"}
        p={{ base: "4", md: "8" }}
      >
        <Flex
          width={{ base: "90%", md: "70%", lg: "40%" }}
          bg="white"
          pb={{ base: "50px", md: "100px", lg: "200px" }}
          mt={{ base: "20px", md: "75px", lg: "100px" }}
          flexDirection="column"
          py={{ base: "50px", md: "75px", lg: "100px" }}
          px={{ base: "10px", md: "15px", lg: "20px" }}
          boxShadow={"md"}
          borderRadius={"2px"}
          gap="1rem"
          height="30rem"
        >
          <Box mx="auto" height={{ base: "130px", md: "200px" }}>
            {" "}
            <Box
              bg="#97DC21"
              borderRadius="full"
              p={{ base: "10px", md: "15px", lg: "20px" }} // Adjust padding for different screen sizes
              color="white"
            >
              <FaCheckCircle size={"5em"} />
            </Box>
          </Box>
          <Text
            fontSize={{ base: "16px", md: "18px", lg: "20px" }}
            textAlign="center"
            color="#353535"
          >
            Enrollment Successful
          </Text>
          <Text
            textAlign="center"
            fontSize={{ base: "12px", md: "14px" }}
            color="#4F4F4F"
            mb={{ base: "20px", md: "30px" }}
          >
            Your enrolment is being reviewed by the admin. You will receive an
            email notification for the outcome of your application.
          </Text>
          <Box mx="auto">
            <Button
              onClick={() => {
                navigate(routes.Application);
              }}
              p="7px"
              type="submit"
              fontSize={{ base: "10px", md: "11px" }}
              borderRadius="2px"
              colorScheme="red"
              size="sm"
            >
              VIEW MY APPLICATIONS
            </Button>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default EnrolmentSuccessful;
